import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const AddNoteModal = ({ lead, onClose, onAddNote }) => {
  const [note, setNote] = useState('');
  const [error, setError] = useState('');

  const handleAdd = () => {
    if (!note?.trim()) {
      setError('Please enter a note');
      return;
    }
    onAddNote(lead?.id, note);
    onClose();
  };

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-background bg-opacity-80">
      <div className="bg-card rounded-lg border border-border shadow-brand-xl w-full max-w-lg">
        <div className="flex items-center justify-between p-6 border-b border-border">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-accent bg-opacity-10 flex items-center justify-center">
              <Icon name="MessageSquare" size={20} color="var(--color-accent)" />
            </div>
            <div>
              <h3 className="font-heading font-semibold text-foreground text-lg">
                Add Note
              </h3>
              <p className="text-sm caption text-muted-foreground">
                {lead?.name} - {lead?.company}
              </p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-muted rounded-lg transition-smooth"
            aria-label="Close modal"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        <div className="p-6">
          <Input
            label="Note"
            type="text"
            placeholder="Enter your note about this lead..."
            value={note}
            onChange={(e) => {
              setNote(e?.target?.value);
              setError('');
            }}
            error={error}
            description="Add context, follow-up details, or important observations"
            required
          />
        </div>

        <div className="flex gap-3 p-6 border-t border-border">
          <Button
            variant="outline"
            onClick={onClose}
            className="flex-1"
          >
            Cancel
          </Button>
          <Button
            variant="default"
            onClick={handleAdd}
            iconName="Plus"
            iconPosition="left"
            className="flex-1"
          >
            Add Note
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AddNoteModal;